import React, { useState, useEffect, memo } from "react";

// TODO: Fix autofocus issue with React. Might need to use useRef hook.
function PhoneNumberInput({
  value = "",
  inputFieldLength = 10,
  onChange,
  autofocus,
  fontSize = 3,
  disabled
}) {
  const [focused, setFocused] = useState(false);
  const [ac, setAc] = useState("");
  const [f3, setF3] = useState("");
  const [l4, setL4] = useState("");

  // Ref use in stateless components is tricky.
  // In the future, use useRef instead!
  let refAc, refF3, refL4;

  useEffect(() => {
    onChange(ac.concat(f3).concat(l4));
  }, [ac, f3, l4, onChange]);

  // NOTE: This is for dev stuff only
  let defaultAc, defaultF3, defaultL4;
  // if (value && value.toString().length) {
  //   const valStr = value.toString();
  //   defaultAc = valStr.substr(0, 3);
  //   defaultF3 = valStr.substr(3, 6);
  //   defaultL4 = valStr.substr(6, 10);
  // }

  const textStyle = {
    color: "dimgrey",
    font: `${fontSize}ch consolas, monospace`,
    marginRight: "0.5ch"
  };

  const focusedStyle = {
    color: "#27e3ba"
  };

  const generateStyle = length => {
    return {
      display: "inline-block",
      border: "none",
      width: `${length + length * 0.5}ch`,
      background:
        "repeating-linear-gradient(90deg, dimgrey 0, dimgrey 1ch, transparent 0, transparent 1.5ch) 0 100%/100% 2px no-repeat",
      color: "dimgrey",
      font: `${fontSize}ch consolas, monospace`,
      letterSpacing: ".5ch",
      outline: "none",
    };
  };

  const handleChange = (el, val) => {
    switch (el) {
      case "ac":
        setAc(val);
        break;
      case "f3":
        setF3(val);
        break;
      case "l4":
        setL4(val);
        break;
      default:
        break;
    }
  };

  const areaCode = (
    <input
      style={{
        ...generateStyle(3),
        ...(focused && { ...focusedStyle })
      }}
      onFocus={() => {
        setFocused(true);
      }}
      onBlur={() => {
        setFocused(false);
      }}
      disabled={disabled}
      maxlength={3}
      value={ac || defaultAc}
      onChange={e => handleChange("ac", e.target.value)}
      onKeyDown={e => {
        if (e.target.value.length === 3) {
          refF3.focus();
        }
      }}
      ref={el => {
        refAc = el;
      }}
      autofocus={autofocus && "true"}
    />
  );

  const first3 = (
    <input
      style={{
        ...generateStyle(3),
        ...(focused && { ...focusedStyle })
      }}
      onFocus={() => {
        setFocused(true);
      }}
      onBlur={() => {
        setFocused(false);
      }}
      disabled={disabled}
      maxlength={3}
      value={f3 || defaultF3}
      onChange={e => handleChange("f3", e.target.value)}
      onKeyDown={e => {
        if (e.target.value.length === 3) {
          refL4.focus();
        } else if (e.target.value.length === 0) {
          refAc.focus();
        }
      }}
      ref={el => {
        refF3 = el;
      }}
    />
  );

  const last4 = (
    <input
      style={{
        ...generateStyle(4),
        ...(focused && { ...focusedStyle })
      }}
      onFocus={() => {
        setFocused(true);
      }}
      onBlur={() => {
        setFocused(false);
      }}
      disabled={disabled}
      maxlength={4}
      value={l4 || defaultL4}
      onChange={e => handleChange("l4", e.target.value)}
      onKeyDown={e => {
        if (e.target.value.length === 0) {
          refF3.focus();
        }
      }}
      ref={el => {
        refL4 = el;
      }}
    />
  );

  return (
    <div>
      <span style={{ ...textStyle, color: "lightgray" }}>+1</span>
      {areaCode}
      <span style={textStyle}>-</span>
      {first3}
      <span style={textStyle}>-</span>
      {last4}
    </div>
  );
}

export default memo(PhoneNumberInput);
